import { render, staticRenderFns } from "./AdminGeneral.vue?vue&type=template&id=36d9c57a&"
import script from "./AdminGeneral.vue?vue&type=script&lang=js&"
export * from "./AdminGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports